import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrderState = () => React.useContext(Context)
export const useServiceOrder = () => useServiceOrderState()?.serviceOrder

const QUERY = gql`
  query ServiceOrder($id: ID) {
    serviceOrder(id: $id, filter: { ignoreSegments: true }) {
      id
      name
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      scheduling
      description
      resumeToken
      slaExpiresAt
      address {
        address
        city
        complement
        country
        latitude
        longitude
        neighborhood
        number
        postcode
        search
        state
      }
      documents {
        id
        src
        type
      }
      status {
        id
        name
      }
      priority {
        id
        name
      }
      tagId
      tag {
        id
        name
        color
      }
      user {
        id
        name
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      place {
        id
        name
        resume
      }
      asset {
        id
        name
        placeId
      }
      checklist {
        id
        name
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
          options {
            id
            name
            reference
            ordination
          }
        }
      }
    }
  }
`

const ServiceOrdersLoader = ({ children }) => {
  const { id, cloneFromId } = useModalData() || {}
  const { data, ...state } = useQuery(QUERY, {
    skip: !id && !cloneFromId,
    variables: { id: id || cloneFromId },
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersLoader
